import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './types';

import { INursery } from 'v2/resources/types/nurseries';
import { ICycle } from 'v2/resources/types/cycles';
import {
  IResponseBiometricsNurseries,
  IResponseHealthMortality,
  IResponseNurseryMortality,
  IResponseQualityParameters,
  IResponseSupply,
  IResponseWaterAnalysisNurseries,
} from 'v2/resources/types/graphics';
import { IGetUsersResponse } from 'v2/resources/types/users';

const dataChat = createSlice({
  name: 'dataChat',
  initialState,
  reducers: {
    setDataChatCycles: (state, action: PayloadAction<ICycle[]>) => {
      return {
        ...state,
        cycles: action.payload,
      };
    },
    setDataChatNurseries: (state, action: PayloadAction<INursery[]>) => {
      return {
        ...state,
        nurseries: action.payload,
      };
    },
    setGraphicSupply: (state, action: PayloadAction<IResponseSupply>) => {
      return {
        ...state,
        graphicSupply: action.payload,
      };
    },
    setGraphicNurseryMortality: (
      state,
      action: PayloadAction<IResponseNurseryMortality[]>
    ) => {
      return {
        ...state,
        graphicNurseryMortality: action.payload,
      };
    },
    setGraphicHealthAnalysis: (
      state,
      action: PayloadAction<IResponseHealthMortality>
    ) => {
      return {
        ...state,
        graphicHealthAnalysis: action.payload,
      };
    },
    setGraphicQualityParameters: (
      state,
      action: PayloadAction<IResponseQualityParameters>
    ) => {
      return {
        ...state,
        graphicQualityParameters: action.payload,
      };
    },
    setGraphicBiometricsParameters: (
      state,
      action: PayloadAction<IResponseQualityParameters>
    ) => {
      return {
        ...state,
        graphicBiometricsParameters: action.payload,
      };
    },
    setGraphicBiometricsNurseries: (
      state,
      action: PayloadAction<IResponseBiometricsNurseries>
    ) => {
      return {
        ...state,
        graphicBiometricsNurseries: action.payload,
      };
    },
    setGraphicWaterAnalysisNurseries: (
      state,
      action: PayloadAction<IResponseWaterAnalysisNurseries>
    ) => {
      return {
        ...state,
        graphicWaterAnalysisNurseries: action.payload,
      };
    },
    setUsers: (state, action: PayloadAction<IGetUsersResponse[]>) => {
      return {
        ...state,
        users: action.payload,
      };
    },
  },
});

export const {
  setDataChatCycles,
  setDataChatNurseries,
  setGraphicSupply,
  setGraphicNurseryMortality,
  setGraphicHealthAnalysis,
  setGraphicQualityParameters,
  setGraphicBiometricsParameters,
  setGraphicBiometricsNurseries,
  setGraphicWaterAnalysisNurseries,
  setUsers,
} = dataChat.actions;
export default dataChat.reducer;
